import { defineMessages } from 'react-intl';

export default defineMessages({
  noAttachments: {
    id: 'frontbucket.attachmentFilmstrip.noAttachments',
    description: 'Text to inform the user that there are no attachments',
    defaultMessage: `There aren't any attachments.`,
  },
  metadataPanelHeading: {
    id: 'frontbucket.mediaViewer.metadataPanelHeading',
    description: 'Heading text in the attachment modal sidebar',
    defaultMessage: 'Attachment details',
  },
  metadataPanelToggleActionLabel: {
    id: 'frontbucket.mediaViewer.metadataPanelToggleActionLabel',
    description:
      'Accessible label for the sidebar open and closed toggle button',
    defaultMessage: 'Toggle attachment panel',
  },
});
